import { useSelector } from 'react-redux';

import { getLogsStore } from '@api/store/logs/actions';

import { UseLogsTableDataRowsInterface, UseLogsTableDataHeadersInterface } from '../Interface';

import { useLogTableRows } from './useLogsTableRows';
import { useLogTableHeaders } from './useLogsTableHeaders';

/**
 *
 * @param param0 props passed to rows type UseLogsTableDataRowsInterface
 * @param param1 props passed to headers type Use
 * @returns
 */

export const useLogsTableData = (
    { onRowIconClick, onRowEmailClick, onBounceDetailsClick }: UseLogsTableDataRowsInterface,
    { selectedEventsCheckboxes, onHeadersEventFilterClick, eventFiltersType }: UseLogsTableDataHeadersInterface
): any => {
    const { logLoading, hasMoreLogs } = useSelector(getLogsStore);

    const rows = useLogTableRows({ onRowIconClick, onRowEmailClick, onBounceDetailsClick });

    const headers = useLogTableHeaders({ selectedEventsCheckboxes, onHeadersEventFilterClick, eventFiltersType });

    return { rows, headers, isLoading: logLoading, hasMoreLogs };
};
